import React from 'react';

const AnnouncementTicker = () => {
  const announcement = "THE COMBINE IS OPEN! 🔥🔥 GET YOUR POWER SCORE NOW 🔥🔥";
  
  return (
    <div className="w-full bg-orange-600 overflow-hidden" data-testid="announcement-ticker">
      <div className="relative flex items-center h-10">
        {/* Scrolling animation container */}
        <div className="animate-marquee whitespace-nowrap flex items-center">
          {/* Repeat the text multiple times for seamless scroll */}
          {[...Array(4)].map((_, i) => (
            <span key={i} className="mx-8 text-black font-black text-sm tracking-wider uppercase">
              ⚡ {announcement} ⚡
            </span>
          ))}
        </div>
        {/* Duplicate for seamless loop */}
        <div className="absolute animate-marquee2 whitespace-nowrap flex items-center">
          {[...Array(4)].map((_, i) => (
            <span key={i} className="mx-8 text-black font-black text-sm tracking-wider uppercase">
              ⚡ {announcement} ⚡
            </span>
          ))}
        </div>
      </div>
      
      {/* CSS for marquee animation */}
      <style jsx="true">{`
        @keyframes marquee {
          0% { transform: translateX(0%); }
          100% { transform: translateX(-100%); }
        }
        @keyframes marquee2 {
          0% { transform: translateX(100%); }
          100% { transform: translateX(0%); }
        }
        .animate-marquee {
          animation: marquee 30s linear infinite;
        }
        .animate-marquee2 {
          animation: marquee2 30s linear infinite;
        }
      `}</style>
    </div>
  );
};

export default AnnouncementTicker;
